import { Observable, skip } from "rxjs";
import { subjectFromObs } from "../subjects";


const obsPersistance: Record<string, Observable<any>> = {

}

export const createPersistantObservable = <T extends any>(key: string, fn: () => Observable<T>) => {

    if (!obsPersistance[key]) {
        obsPersistance[key] = subjectFromObs({
            initialValue: null,
            observable: fn()
        })
    }

    return obsPersistance[key].pipe(skip(1)) as Observable<T>;
}